import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["body"];

  connect() {
    this.viewport = this.bodyTarget.parentElement;
    this.viewportWidth = undefined;

    if (!window.$hsCarouselCollection) {
      window.$hsCarouselCollection = [];
    }

    this.carouselInstance =
      window.HSCarousel.getInstance(this.element) || new window.HSCarousel(this.element);

    this.recalculateHeight();
    this.observeViewport();
  }

  observeViewport() {
    this.resizeObserver = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;

      if (width === this.viewportWidth) {
        return;
      }

      this.viewportWidth = width;

      if (width <= 0) {
        return;
      }

      this.recalculateHeight();
      this.carouselInstance.recalculateWidth();
    });

    this.resizeObserver.observe(this.viewport);
  }

  recalculateHeight() {
    const { element } = this;
    const body = element.querySelector(".hs-carousel-body");

    if (element.dataset.carouselAutoHeight === "true") {
      element.style.removeProperty("height");
      body?.style.removeProperty("height");
      return;
    }

    const parent = element.parentElement;
    let carouselHeight = parent.clientHeight;

    // fallback height when carousel loads img in a modal
    if (carouselHeight === 0) {
      const img = element.querySelector("img");
      if (img && img.naturalHeight > 0) {
        carouselHeight = img.naturalHeight;
      } else {
        carouselHeight = 400;
      }
    }

    element.style.height = `${carouselHeight}px`;
    if (body) {
      body.style.height = `${carouselHeight}px`;
    }
  }
}
